/**
 *
 * CheckIcon
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { green500, red700 } from 'styles/colors';

const Icon = styled(FontAwesomeIcon)`
  &.fa-check {
    color: ${green500};
  }
  &.fa-times {
    color: ${red700};
  }
`;

function CheckIcon(props) {
  const { check, ...rest } = props;
  const icon = check ? 'check' : 'times';
  const alias = check ? 'ok' : 'no';
  return <Icon icon={icon} alias={alias} fixedWidth {...rest} />;
}

CheckIcon.propTypes = {
  check: PropTypes.bool,
};

export default CheckIcon;
